import img29part2 from '@/assets/img/news/29_2.jpg';
import img29part3 from '@/assets/img/news/29_3.jpg';

export const allNews = [
  {
    date: 'May 8, 2025',
    title: 'How Renderings Help You Sell During the Excavation Stage',
    description: 'Effective 3D renderings as a sales tool for real estate projects before construction begins',
    id: 'renderings-help',
    jsx: () => (
      <div class="novelty__text">
        <p>Selling real estate before construction begins may seem like a challenge — but today’s developers are doing it successfully with the help of high-quality renderings. At the excavation stage, there are no walls, finishes, or landscaping yet. However, with the right visualization tools, even a bare construction site can become a compelling vision of the future.</p>
        <p><b>The Power of Vision: Selling the Dream</b></p>
        <p>Modern buyers think visually. Floor plans and descriptions alone are no longer enough to spark interest or inspire early investment. Renderings bridge the gap. They show not just what the building will look like, but what life in that space could be. This helps create an emotional connection to the project long before completion.</p>
        <p><b>Why Renderings Work at the Excavation Stage</b></p>
        <ol style="margin-left: 50px">
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Trust Through Clarity</b>
            <p>Photorealistic 3D renderings build trust. They tell the buyer: “This is what we’re building — and this is how it will look.” Renderings help convey layout, finishes, lighting, and scale, answering questions before they’re even asked.</p>
          </li>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Marketing from Day One</b>
            <p>Renderings give developers and agents ready-to-use materials for promotion. Social media, presentations, brochures — 3D visuals let you start selling before the foundation is even poured.</p>
          </li>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Standing Out from the Competition</b>
            <p>At the pre-sale stage, many projects look similar in terms of timeline and location. A striking, professional rendering helps your offer stand out and draw attention.</p>
          </li>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Accelerating Sales</b>
            <p>Pre-sales often play a key role in securing financing. The sooner a buyer sees a clear and appealing vision of the future, the sooner they make a decision. Renderings significantly speed up that process.</p>
          </li>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>A Personal Connection</b>
            <p>Whether it's a family imagining life in a new home or an investor assessing rental potential, renderings turn abstract plans into a tangible and desirable future.</p>
          </li>
        </ol>
        <p><b>Why Choose Getfloorplan</b></p>
        <p>At Getfloorplan, we transform 2D floor plans and architectural drawings into high-quality 3D renderings — quickly, affordably, and tailored to your project needs. Whether you’re at the concept stage or already under construction, we help bring your vision to life before the first brick is laid.</p>
        <p><b>Our renderings offer:</b></p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            <b>Speed</b> — Ready within 24 hours
          </li>
          <li class="margin-none">
            <b>All-in-One</b> — Includes 2D floor plans, 3D layouts, photorealistic renders, and 360° video
          </li>
          <li class="margin-none">
            <b>Custom Style</b> — We create a unique visual identity for each project
          </li>
          <li class="margin-none">
            <b>Branding</b> — Your logo, brand colors, and fonts integrated seamlessly
          </li>
          <li class="margin-none">
            <b>Versatility</b> — Optimized for websites, presentations, and printed materials
          </li>
          <li class="margin-none">
            <b>Flexibility</b> — Easy to edit and update throughout the project lifecycle
          </li>
        </ul>
        <p>Selling during the excavation stage is not only possible — it’s profitable. With high-quality 3D renderings from Getfloorplan, you can attract attention, build trust, and secure pre-sales long before construction begins. Let your vision start working for you today.</p>
      </div>
    ),
    thumb: 'news/49.jpg',
  },
  {
    date: 'May 2, 2025',
    title: 'How AI Technologies are Changing the Real Estate Market: The Future of Visualization with Getfloorplan',
    description: 'AI and visualization help improve customer engagement and trust in the real estate market.',
    id: 'ai-technologies-changing-life',
    jsx: () => (
      <div class="novelty__text">
        <p>The modern real estate market is rapidly evolving under the influence of technology. One of the key trends is the use of visualization — 2D and 3D floor plans, as well as AR and VR solutions. These tools are increasingly becoming standard in the sale and rental of real estate.</p>
        <p>Buyers now expect more than just photos and descriptions. Accurate and visually clear 2D/3D floor plans provide a complete understanding of a space, while virtual tours allow clients to "walk through" a property without leaving their home. This is particularly important when buying properties in new developments or when remotely selecting a home.</p>
        <p>AR and VR solutions enable real estate agencies and developers to offer clients a new level of property presentation, increasing engagement and trust.</p>
        <p>Getfloorplan helps make visualization accessible and effective. We create high-quality 2D and 3D floor plans, renders, and tours based on blueprints or BTI plans — quickly, accurately, and tailored to the client's needs.</p>
        <p>Technology is changing the approach to real estate sales. Visualization is already becoming an integral part of the process. At Getfloorplan, we believe this is the future, and we are ready to be a part of these changes alongside our clients and partners.</p>
      </div>
    ),
    thumb: 'news/48.jpg',
  },
  {
    date: 'April 25, 2025',
    title: '5 Mistakes When Creating Floor Plans and How to Avoid Them',
    description: 'An overview of the most common mistakes in floor plan design and useful tips for preventing them',
    id: 'mistakes',
    jsx: () => (
      <div class="novelty__text">
        <p>Designing floor plans is a key part of the work for architects, designers, and real estate agents. Accurate and clear plans help not only to better visualize the space but also to avoid mistakes that can lead to client dissatisfaction and even financial losses.</p>
        <p>Let’s look at the most common mistakes:</p>
        <ol style="margin-left: 50px">
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Delegate work to AI.</b>
            <p>Automatic 2D and 3D floor plans, renders, and 360 tours from Getfloorplan will save you time.</p>
          </li>
          <p style="margin-bottom: 1rem"><b>How to avoid: </b>For accuracy, always use reliable data sources (e.g., BTI plans), as well as software that helps maintain the correct scale and proportions. If creating a 3D visualization, make sure that the sizes of objects in the plan correspond to real-life dimensions.</p>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Incorrect Placement of Windows and Doors</b>
            <p>Another common mistake is the incorrect placement of windows and doors, which affects not only the aesthetic perception but also the functionality of the room. For example, windows may be positioned in such a way that they do not provide enough natural light, or doors may obstruct comfortable movement around the room.</p>
          </li>
          <p style="margin-bottom: 1rem"><b>How to avoid: </b>Always consider not only the appearance but also the convenience. Make sure the doors and windows are positioned to maximize space usage. It’s best to consult with architects or interior designers who know how to balance functionality and aesthetics.</p>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Neglecting Ventilation and Lighting</b>
            <p>Underestimating the importance of ventilation and lighting during the design process can result in creating spaces that are uncomfortable to live in. For example, if a bedroom lacks sufficient natural light or a bathroom lacks good ventilation, it can impact the comfort of future residents.</p>
          </li>
          <p style="margin-bottom: 1rem"><b>How to avoid: </b>When designing floor plans, take into account the importance of ventilation and lighting. Ensure that windows provide adequate light and that the ventilation system will function effectively. This is especially crucial in spaces like kitchens and bathrooms. Keep both natural and artificial lighting in mind when creating the plan.</p>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Undervaluing Functional Zones</b>
            <p>A frequent mistake is paying insufficient attention to functional zones. For example, a poorly planned kitchen or bathroom can be inconvenient to use. Often, property owners want to fit as many functions as possible into one room, forgetting that the space should be comfortable and ergonomic.</p>
          </li>
          <p style="margin-bottom: 1rem"><b>How to avoid: </b>When designing, it’s important to allocate functional zones correctly, especially in small spaces. Use 3D visualizations to see how different zones will interact with each other. Think about the movement of people through the space and pay attention to ergonomics.</p>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Failure to Account for Future Changes</b>
            <p>Many floor plan designs are created without considering future changes. This may involve potential remodeling, changes in the organization of space, or the need for additional furniture. Without these factors, the plan may become less flexible in the future.</p>
          </li>
          <p style="margin-bottom: 1rem"><b>How to avoid: </b>Always leave space for changes when designing. For example, use flexible furniture and layout solutions that allow clients to adapt the space to their needs in the future. When creating visualizations, try to show potential layout options so that the client can see how the space could be adapted.</p>
        </ol>
        <p>Creating accurate and functional floor plans is an art that requires attention to detail. By avoiding common mistakes such as incorrect proportions, poor placement of windows and doors, and underestimating ventilation and lighting, you can create a more comfortable and pleasant space for your clients. Using 3D visualizations and thoughtful design will help you improve the quality of your product and increase client satisfaction.</p>
        <p>At Getfloorplan, we are always ready to help you avoid these mistakes by providing high-quality and accurate visualizations within 24 hours, helping your business stay ahead!</p>
      </div>
    ),
    thumb: 'news/47.jpg',
  },
  {
    date: 'April 11, 2025',
    title: 'AI Rendering Accelerates Sales: How Photorealistic Visuals Are Transforming the Market',
    description: 'Modern visualization technologies are rapidly changing the rules of marketing and sales.',
    id: 'ai-rendering',
    jsx: () => (
      <div class="novelty__text">
        <p>Modern visualization technologies are rapidly changing the rules of marketing and sales.</p>
        <p>Thanks to photorealistic renders powered by artificial intelligence, companies are significantly reducing the path from product presentation to purchase.</p>
        <p>Today, visual content is the key driver of buying decisions. Customers are more likely to choose products and services they can easily imagine in real life. That’s exactly what AI rendering delivers — detailed, lifelike images created without the need for studios, models, or physical prototypes.</p>
        <p>What it brings to your business</p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            Reduced content production costs — a single render can be adapted to dozens of variants (colors, materials, backgrounds).
          </li>
          <li class="margin-none">
            Faster time-to-market — showcase products or spaces before they even exist.
          </li>
          <li class="margin-none">
            Deep personalization — customers see the product with their own preferences applied.
          </li>
          <li class="margin-none">
            Higher conversions — realistic visuals build trust and motivate purchases.
          </li>
        </ul>
        <p>AI rendering is already making an impact across industries — from real estate and interior design to e-commerce, furniture, and fashion.</p>
        <p>Developers are selling properties "off the render," and brands are showcasing products in lifelike environments.</p>
        <p>AI renders aren’t just beautiful. They’re powerful business tools that shorten the sales cycle, boost engagement, and help you sell faster.</p>
        <p>You can order Render Set and Max Set — and start using the power of realistic visualization in your business.</p>
        <p>Contact our team or leave a request — we’ll help you find the best solution for your goals.</p>
      </div>
    ),
    thumb: 'news/46.jpg',
  },
  {
    date: 'April 04, 2025',
    title: '5 Life Hacks for Selling Real Estate Faster',
    description: 'Simple and effective tips to speed up deals and make your listings more attractive.',
    id: 'five-life-hacks',
    jsx: () => (
      <div class="novelty__text">
        <p>Want to sell real estate faster and attract more clients? Here are five powerful life hacks to make your listings stand out and boost conversions.</p>
        <ol style="margin-left: 50px">
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Delegate work to AI.</b> Automatic 2D and 3D floor plans, renders, and 360 tours from Getfloorplan will save you time.
          </li>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Use different visual formats.</b> 2D and 3D floor plans, photorealistic renders, and 360-degree videos make listings more engaging.
          </li>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Create realistic visualizations.</b> Furnished images help buyers imagine themselves in the space, building trust and increasing interest.
          </li>
          <li class="margin-none" style="margin-bottom: 1rem">
            <b>Write compelling descriptions.</b> Highlight key features, benefits, infrastructure details, and include a strong call to action.
          </li>
          <li class="margin-none">
            <b>Ensure fast content loading and quick responses.</b> Speed is crucial for capturing and retaining buyer attention.
          </li>
        </ol>
        <p>
          By implementing these life hacks, you can accelerate the real estate sales process and make your listings more effective. Instead of spending days creating marketing materials, let AI handle it.
        </p>
        <p>
          Our AI can do the work of an entire design team in just 24 hours, providing you with high-quality marketing materials for your real estate listings.
        </p>
      </div>
    ),
    thumb: 'news/45.jpg',
  },
  {
    date: 'March 27, 2025',
    title: 'Virtual Tours Are Now 3X Faster – Load Faster, Sell Faster',
    description: 'Getfloorplan’s upgrade reduces tour loading time by 3X, making the property buying process even more convenient and efficient.',
    id: 'virtual-tours-faster',
    jsx: () => (
      <div class="novelty__text">
        <p>In today’s competitive real estate market, speed is everything. A listing that loads slowly can cause potential buyers to lose interest and move on. That’s why <b>Getfloorplan</b> has made a major upgrade—our virtual tours now load <b>3 times faster</b>, creating a seamless and engaging experience that helps <b>sell properties faster and keep clients happy</b>.</p>
        <p><b>How Faster Virtual Tours Lead to Faster Sales</b></p>
        <p>
          A slow-loading virtual tour can mean lost opportunities. Buyers browsing listings online expect <b>instant access</b> to property details, and any delay can result in frustration or even abandonment. With <b>3X faster loading speeds</b>, Getfloorplan ensures:
        </p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            <b>Less Waiting, More Engagement:</b> Buyers can instantly explore properties without delays, leading to <b>longer viewing times</b> and a stronger emotional connection.
          </li>
          <li class="margin-none">
            <b>Faster Decision-Making:</b> The smoother the experience, the quicker buyers can evaluate a property and move toward a purchase.
          </li>
          <li class="margin-none">
            <b>Higher Conversion Rates:</b> Listings with high-quality, fast-loading virtual tours attract more serious buyers and generate more inquiries.
          </li>
          <li class="margin-none">
            <b>Better Buyer Experience:</b> A fast, immersive tour builds confidence, making buyers more likely to commit without needing multiple physical visits.
          </li>
        </ul>
        <p><b>Why Clients Love This Upgrade</b></p>
        <p>
          Speed isn’t just a technical improvement — it directly enhances the <b>buyer experience</b> and makes life easier for <b>sellers and realtors</b>. Here’s why clients appreciate this change:
        </p>
        <p><b>Buyers Stay Engaged Longer:</b> When tours load instantly, buyers spend more time exploring properties instead of getting frustrated with buffering screens.</p>
        <p><b>Smooth Navigation for a Seamless Experience:</b> A lag-free tour makes it easier to explore every detail, increasing the likelihood of a property standing out.</p>
        <p><b>Sellers Get Faster Offers:</b> More engagement and quicker decision-making mean sellers <b>receive offers sooner</b> and close deals faster.</p>
      </div>
    ),
    thumb: 'news/44.jpg',
  },
  {
    date: 'March 21, 2025',
    title: 'A New Era in Real Estate Sales: Style Switching in 360 Tours',
    description: 'Getfloorplan introduces an innovative feature that helps sell properties faster and more effectively – AI-powered style switching in 3D tours, delivered in just 24 hours.',
    id: 'new-era',
    jsx: () => (
      <div class="novelty__text">
        <p><b>How Does It Work?</b></p>
        <p>
          Now, buyers can explore the same property in three different styles with a single click. The virtual tour allows them to instantly switch between interior designs, furniture setups, and color schemes, making it easier to visualize their future home.
        </p>
        <p><b>Why Is This Important for Sales?</b></p>
        <p>
          Visualization is key in real estate decision-making. This new feature solves multiple challenges at once:
        </p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            <b>Increases engagement</b> – buyers spend more time exploring properties with different styles.
          </li>
          <li class="margin-none">
            <b>Speeds up decision-making</b> – no need for imagination; buyers see ready-made interior options.
          </li>
          <li class="margin-none">
            <b>Expands the target audience</b> – a single property becomes appealing to buyers with different tastes.
          </li>
          <li class="margin-none">
            <b>Boosts conversion rates</b> – better presentation increases the likelihood of purchase decisions.
          </li>
        </ul>
        <p><b>Who Benefits from This?</b></p>
        <p>
          Style switching is especially useful for realtors, developers, and property investors. It enhances property presentation, reduces negotiation time, and improves overall sales efficiency.
        </p>
        <p><b>Give Buyers More Choice and Sell Faster!</b></p>
        <p>
          Getfloorplan’s AI technology generates a 3D tour with three design styles in just 24 hours. Try this game-changing tool and see the difference for yourself.
        </p>
      </div>
    ),
    thumb: 'news/43.jpg',
  },
  {
    date: 'March 12, 2025',
    title: 'New Update: High Speed, Ultra High Quality, and Style Selection Inside a Single Widget',
    description: 'A powerful tool to sell properties faster and more effectively',
    id: 'new-update',
    jsx: () => (
      <div class="novelty__text">
        <p><b>What’s New?</b></p>
        <p><b>3x Faster Loading Speed</b></p>
        <p>
          Your tours will now load <b>3 times faster</b>, providing a smoother and more enjoyable experience.
        </p>
        <p><b>Multiple Styles in One Tour</b></p>
        <p>
          Now, you can explore <b>3 different styles</b> for the same property with a single click. Simply use the selection button to switch between styles effortlessly.
        </p>
        <p><b>Ultra High-Quality 4K Resolution</b></p>
        <p>
          For <b>Max Set</b> users, we've upgraded the quality to <b>Ultra High (4K resolution)</b>, delivering even more photorealistic visuals.
        </p>
        <p><b>Dual-Link Access for a Smooth Transition</b></p>
        <p>
          For the next two months, you’ll receive both the previous and new versions of the tour. This way, you can switch between them and adapt seamlessly to the update.
        </p>
        <p><b>Faster Sales and a Better Buying Experience</b></p>
        <p><b style="color: #FFA900">For Sellers:</b></p>
        <p>
          A high-speed, high-quality virtual tour means faster decision-making from potential buyers. With enhanced photorealism and multiple styles available in one tour, properties can be showcased more effectively, increasing engagement and leading to quicker sales.
        </p>
        <p><b style="color: #FFA900">For Buyers:</b></p>
        <p>
          A detailed and immersive virtual tour allows buyers to explore a property in different styles, helping them visualize potential renovations or furniture placements. This makes decision-making easier and more confident, reducing the need for multiple physical visits.
        </p>
        <p>Experience the future of virtual tours today.</p>
      </div>
    ),
    thumb: 'news/42.jpg',
  },
  {
    date: 'March 07, 2025',
    title: 'Last Chance to Save: Get Your Floor Plans at Old Prices!',
    description: 'Limited-time offer – prices increase after march 11, 2025!',
    id: 'last-chance',
    jsx: () => (
      <div class="novelty__text">
        <p>This March, you have a unique opportunity to purchase packages of 5 to 50 floor plans at old prices and top up your Getfloorplan account.</p>
        <p>What does this mean?</p>
        <p>
          You can choose any of our packages, including Plus, Render, Max, and others — for example, 15 units of the Basic package — and buy them at a discounted price.
        </p>
        <p>Benefits of this offer:</p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            Purchased packages are valid indefinitely, so you can use them at any time.
          </li>
          <li class="margin-none">
            After topping up your account, you will receive a unique promo code to use when creating floor plans.
          </li>
        </ul>
        <p>Offer validity:</p>
        <p>This offer is available only until March 11, 2025!</p>
        <p>But hurry! This month, we are releasing a new update and increasing our prices. Take advantage of the current rates while they are still available!</p>
        <p>How to claim this offer:</p>
        <p>Email us at <a href="mailto:customerservice@getfloorplan.com"> customerservice@getfloorplan.com</a>, and our manager will assist you with the purchase process.</p>
        <p>Don't miss the opportunity to save! This special offer is valid only until March 11, 2025—secure your packages before the price increase!</p>
      </div>
    ),
    thumb: 'news/41.jpg',
  },
  {
    date: 'February 28, 2025',
    title: 'Getfloorplan: Floor Plans in Any Language for Successful Real Estate Sales',
    description: 'In the world of real estate, it’s not just about the property itself but also how it is presented to potential buyers. One of the key elements of a successful sale is a high-quality and easy-to-understand floor plan that helps buyers make decisions faster.',
    id: 'floor-plans-in-any-language',
    jsx: () => (
      <div class="novelty__text">
        <p><b>Show Homebuyers 360° Tours in Their Native Language</b></p>
        <p>
          One of the most crucial aspects of successful real estate sales is the ability to convey information in a way that buyers can easily understand. At Getfloorplan, we recognize that not all clients speak the same language. That’s why we offer a unique solution: our floor plans can be presented in any language in the world.
        </p>
        <p>
          We can customize the language in the widget, making your floor plans accessible to users worldwide. Whether you’re working with clients from Europe, Asia, the Middle East, or North America, the floor plan will be displayed in their native language.
        </p>
        <p><b>This offers several advantages:</b></p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            Global Audience: Expand your client base and reach buyers worldwide by providing information in their native language.
          </li>
          <li class="margin-none">
            Easy Comprehension: Buyers will better understand the details, increasing their trust and engagement in the purchasing process.
          </li>
          <li class="margin-none">
            Eliminating Language Barriers: Your floor plans will be clear and accessible to all clients, regardless of their country of residence.
          </li>
        </ul>
        <p><b>How Does It Work?</b></p>
        <p>To request a customized language adjustment, contact us at <a href="mailto:support@getfloorplan.com">support@getfloorplan.com</a>.</p>
      </div>
    ),
    thumb: 'news/40.jpg',
  },
  {
    date: 'February 21, 2025',
    title: 'AI in Real Estate: How Getfloorplan Speeds Up Sales and Simplifies Work ',
    description: 'Artificial intelligence is transforming the real estate market, making the visualization process fast, convenient, and accessible to developers and listing platforms.',
    id: 'aI-in-real-estate',
    jsx: () => (
      <div class="novelty__text">
        <p>
          Our AI enables developers and listing platforms to receive professional 2D and 3D floor plans, virtual tours, and renders in just 24 hours.
        </p>
        <p><b>What Does AI Do in 24 Hours?</b></p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            Generates detailed 2D and 3D floor plans.
          </li>
          <li class="margin-none">
            Creates high-quality interior renders.
          </li>
          <li class="margin-none">
            Builds interactive 360-degree virtual tours.
          </li>
          <li class="margin-none">
            Showcases properties in the best possible way, even before construction is completed.
          </li>
        </ul>
        <p><b>How Does This Help Developers and Listing Platforms?</b></p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            Fast property presentation – ready-to-use visualizations without long approvals or delays.
          </li>
          <li class="margin-none">
            Saves time and budget – automation reduces costs for photography, 3D rendering, and marketing materials.
          </li>
          <li class="margin-none">
            Higher conversion rates – professional visualizations make listings more attractive and easier for clients to understand.
          </li>
          <li class="margin-none">
            Interactive 360° tours – potential buyers can explore properties from anywhere in the world.
          </li>
          <li class="margin-none">
            Custom solutions – branding, customization, and unique style development. To request a custom order, contact us at <a href="mailto:support@getfloorplan.com">support@getfloorplan.com</a>.
          </li>
          <li class="margin-none">
            Global reach – digital solutions allow properties to be showcased remotely and connect with clients worldwide.
          </li>
        </ul>
        <p>With Getfloorplan, developers and listing platforms gain powerful tools to accelerate sales and enhance real estate presentations.</p>
      </div>
    ),
    thumb: 'news/39.jpg',
  },
  {
    date: 'February 14, 2025',
    title: 'New Feature in Getfloorplan: All Styles in One Widget!',
    description: 'A game-changer for real estate visualization',
    id: 'all-styles-in-one-widget',
    jsx: () => (
      <div class="novelty__text">
        <p>
          We are excited to introduce a new feature in Getfloorplan! Our widget now includes a style switcher that allows you to display various visualization styles in one place. This is a great opportunity for real estate sellers to stand out in the market and attract more attention to their listings.
        </p>
        <p><b>What does this mean for you?</b></p>
        <p>
          With the new style switcher in the widget, potential buyers can instantly view different visualization options. This creates a “wow” effect, highlights the advantages of the property, and simplifies the decision-making process.</p>
        <p><b>What are the benefits of this feature?</b></p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            All styles in one place – buyers can choose the visualization style they like best.
          </li>
          <li class="margin-none">
            Increased engagement – switching styles makes interacting with the widget more dynamic and enjoyable.
          </li>
          <li class="margin-none">
            Enhanced competitiveness – a unique opportunity to offer clients multiple ways to present real estate.
          </li>
        </ul>
        <p><b>How to get access?</b></p>
        <p>This feature is currently available for pre-order. If you want to be among the first to test and use the new style switcher in your widget, contact us at <a href="mailto:support@getfloorplan.com">support@getfloorplan.com</a>.</p>
        <p>Don’t miss the chance to stand out from the competition and impress future buyers with a modern and stylish approach to real estate visualization! </p>
      </div>
    ),
    thumb: 'news/38.jpg',
  },
  {
    date: 'February 07, 2025',
    title: 'High-Quality Floor Plan is the Key to a Successful Home Sale',
    description: 'How a well-designed floor plan can speed up property sales',
    id: 'high-quality-floor-plan',
    jsx: () => (
      <div class="novelty__text">
        <p>
          In today's real estate market, where competition is increasing daily, a high-quality floor plan has become a crucial tool for successfully selling a property. It helps potential buyers better understand the space and significantly increases the chances of a quick transaction.
        </p>
        <p><b>The Importance of a High-Quality Floor Plan</b></p>
        <p>
          1. <b style="margin-left: 30px">Clear Representation of Space</b>
          <p style="margin-left: 50px">A floor plan provides potential buyers with a clear understanding of the layout, dimensions, and functionality of the rooms. This allows them to assess whether the property meets their needs.</p>
        </p>
        <p>
          2.<b style="margin-left: 30px">Time Savings for All Parties</b>
          <p style="margin-left: 50px">Buyers can immediately determine if the property suits them, reducing the number of unnecessary viewings. This is especially beneficial for real estate agents, enabling them to work with more interested clients.</p>
        </p>
        <p>
          3.<b style="margin-left: 30px">Increased Trust in Listings</b>
          <p style="margin-left: 50px">Listings with high-quality floor plans look more professional and inspire trust. This is particularly relevant for remote buyers who cannot visit the property immediately.</p>
        </p>
        <p>
          4.<b style="margin-left: 30px">Optimization of Marketing Strategy</b>
          <p style="margin-left: 50px">Proper real estate visualization helps promote listings more effectively on the internet and social media, attracting more potential buyers.</p>
        </p>
        <p><b>Simplifying the Creation of High-Quality Floor Plans with Getfloorplan</b></p>
        <p>Creating an accurate and visually appealing floor plan traditionally requires time and professional skills. Getfloorplan's artificial intelligence significantly simplifies and speeds up this process.</p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            <b>Automatic Floor Plan Generation:</b>  Simply upload a photo or blueprint, and the system will automatically generate an accurate digital floor plan.
          </li>
          <li class="margin-none">
            <b>Photorealistic Visualization:</b> Getfloorplan not only creates schematics but also detailed 2D and 3D models, including renderings, making the real estate presentation as clear as possible.
          </li>
          <li class="margin-none">
            <b>Fast Processing:</b> Thanks to powerful AI processing, a floor plan can be ready within 24 hours, which is significantly faster compared to traditional methods.
          </li>
          <li class="margin-none">
            <b>Flexibility and Customization:</b> Users can adjust the plan to their preferences, choosing colors, materials, and furniture.
          </li>
        </ul>
        <p>A high-quality floor plan is a powerful tool that enhances sales efficiency. The Getfloorplan service allows agents, developers, and private sellers to quickly and easily create professional floor plans that attract buyers and accelerate transactions. Investing in high-quality visualization helps find a buyer much faster.</p>
      </div>
    ),
    thumb: 'news/37.jpg',
  },
  {
    date: 'January 22, 2025',
    title: 'The New American Style',
    description: 'A harmony of tradition and modernity for successful property sales.',
    id: 'american-style',
    jsx: () => (
      <div class="novelty__text">
        <p>
          We are excited to introduce the <b>New American Style</b> — a
          modern approach to interior design that seamlessly blends classic
          traditions with contemporary trends. This style is perfect for
          property staging and creating cozy living spaces. By combining
          timeless aesthetics with modern functionality, it offers a unique
          charm that captivates buyers and accelerates the sales process.
        </p>
        <p><b>Why Choose the New American Style?</b></p>
        <p>
          This style not only transforms the interior but also boosts its
          market value. Soft tones, natural materials, and innovative layouts
          create a welcoming atmosphere where buyers can easily envision
          themselves living. This emotional connection helps them make
          quicker decisions and simplifies the selling process.
        </p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            <b>Living Room:</b> Styled with warm neutral tones, cozy
            furniture, and an open layout, it’s ideal for relaxation and
            conversation.
          </li>
          <li class="margin-none">
            <b>Kitchen:</b> A perfect blend of clean lines and traditional
            elements creates a functional and stylish space for everyday
            life.
          </li>
          <li class="margin-none">
            <b>Children’s Room:</b> Thoughtfully designed with practical
            storage solutions and a soothing, playful vibe.
          </li>
          <li class="margin-none">
            <b>Bedroom:</b> A personal oasis of calm, featuring soft textures
            and carefully selected decor for ultimate relaxation.
          </li>
          <li class="margin-none">
            <b>Bathroom:</b> Modern and fresh, with sleek surfaces,
            minimalist fixtures, and a calming color palette.
          </li>
        </ul>
        <p>
          The New American Style highlights the best features of your
          property, helping it stand out in the market, sell faster, and
          command a higher price. Place your order at
          <a href="https://getfloorplan.com/pricing"> Getfloorplan.com</a> and
          see how this style can transform your space!
        </p>
      </div>
    ),
    thumb: 'news/36.jpg',
  },
  {
    date: 'January 10, 2025',
    title: 'January Special: Old Prices All Month Long!',
    description: 'This January, take advantage of a unique opportunity to purchase packages of 5 to 50 floor plans at last year’s prices and top up your Getfloorplan account.',
    id: 'january-special',
    jsx: () => (
      <div class="novelty__text">
        <p>
          This January, take advantage of a unique opportunity to purchase
          packages of 5 to 50 floor plans at last year’s prices and top up
          your Getfloorplan account.
        </p>
        <p><b>What does this mean?</b></p>
        <p>
          You can choose any of our packages, including <b>Plus, Render, Max,
          </b> or others — for example, <b>15 units of the Basic package</b> —
          and buy them at a discounted price.
        </p>
        <p><b>Benefits of this offer:</b></p>
        <ul style="margin-left: 50px">
          <li class="margin-none">
            Purchased packages are <b>valid indefinitely</b>,
            so you can use them at any time.
          </li>
          <li class="margin-none">
            After topping up your account, you’ll receive a
            <b>unique promo code</b> to use when creating your floor plans.
          </li>
        </ul>
        <p><b>Offer validity:</b></p>
        <p>This offer is available until <b>January 31st.</b></p>
        <p><b>How to claim this offer:</b></p>
        <p>Email us at
          <a href="mailto:customerservice@getfloorplan.com"> customerservice@getfloorplan.com</a>,
          and our manager will guide you through the purchase process.
        </p>
        <p><b>Don’t miss this opportunity to save! This special offer is valid only in January.</b></p>
      </div>
    ),
    thumb: 'news/35.jpg',
  },
  {
    date: 'December 20, 2024',
    title: 'Free Demo Floor Plan: New Offer from Getfloorplan',
    description: 'Try our service risk-free with a free demo plan',
    id: 'free-demo-floor-plan',
    jsx: () => (
      <div class="novelty__text">
        <p>
          We’re excited to introduce a special offer for our clients! Now, when you purchase a package of 6
          or more floor plans, you can receive a test floor plan completely free.
        </p>
        <b>How does it work?</b>
        <p>It’s simple:</p>
        <p style="margin-left: 30px">
          1. Submit a request on our website.
          <br></br>
          2. Click the
          <a href="https://getfloorplan.com/#gallerySection"> "Ask demo" </a>
          button and let us know you’re interested in a demo for your project.
          <br></br>
          3. Our client manager will contact you to clarify project details and create a personalized offer.
        </p>
        <p>To create the test floor plan, you’ll just need to provide a single file with a floor layout to the manager.</p>
        <p><b>Why is this beneficial?</b></p>
        <ul style="margin-left: 50px">
          <li class="margin-none">Test the quality of our services at no additional cost.</li>
          <li class="margin-none">Receive a floor plan tailored perfectly to your project.</li>
          <li class="margin-none">Ensure Getfloorplan is the reliable partner you need for your tasks.</li>
        </ul>
        <p>Don’t miss this opportunity to start working with us on the best terms!</p>
      </div>
    ),
    thumb: 'news/34.jpg',
  },
  {
    date: 'December 6, 2024',
    title: 'Unique Window Views',
    description: 'Highlight the Uniqueness of Your Project with Getfloorplan',
    id: 'unique-window-views',
    jsx: () => (
      <div class="novelty__text">
        <p><b>Why is this important?</b></p>
        <p>
          A unique window view not only enhances the layout but also strengthens the competitive advantages
          of your real estate project. Whether it’s a view of the urban skyline, a cozy courtyard, or a scenic
          park, we will create an image that highlights your project and makes it memorable for potential buyers.
        </p>
        <p><b>Benefits of a Unique Window View:</b></p>
        <li class="margin-none">Helps your property stand out in the real estate market.</li>
        <li class="margin-none">Highlights the advantages of the location and infrastructure.</li>
        <li class="margin-none">Enhances the visual appeal of marketing materials.</li>
        <li>Allows buyers to imagine themselves living in the property.</li>
        <p><b>How does it work?</b></p>
        <p>
          When placing an order for a floor plan, simply leave a comment with your preferences for the window
          view or email us at <a href="mailto:support@getfloorplan.com">support@getfloorplan.com</a>. We will
          carefully review your request and provide a solution that perfectly fits your project.
        </p>
        <p><b>An individual approach to details is what makes your property special.</b></p>
        <p>
          With Getfloorplan, you can take your projects to the next level. Trust us to help make your property
          stand out and attract attention.
        </p>
        <p>Start today — your success begins with the details!</p>
      </div>
    ),
    thumb: 'news/33.jpg',
  },
  {
    date: 'November 20, 2024',
    title: 'Update: New Style "Elegance"',
    description: 'Create timeless and sophisticated property visuals',
    id: 'style-elegance',
    jsx: () => (
      <div class="novelty__text">
        <p>Step into a world of sophistication and grace with our newest design style — Elegance!</p>
        <p>
          We are present style Elegance. This timeless style combines refined simplicity with carefully selected
          materials to create interiors that are both inviting and unforgettable.
        </p>
        <p><b>Why "Elegance"?</b></p>
        <p>
          The Elegance style is perfect for showcasing properties in their best light. Soft neutral tones, natural
          materials, and graceful forms come together to create an atmosphere of comfort and sophistication. This
          design not only highlights the beauty of a space but also allows potential buyers to immediately picture
          themselves living there, making it easier to secure a sale.
        </p>
        <b>Ready to try it?</b>
        <p>
          You can now select the Elegance style when ordering property visualizations on our website. Add timeless
          beauty and charm to your projects, helping buyers connect with your property on an emotional level.
        </p>
        <b>How to Order?</b>
        <p class="margin-none">
          <b>Step 1: </b>
          Visit the storefront section at
          <a href="https://getfloorplan.com/#showcase"> getfloorplan.com</a>
        </p>
        <p class="margin-none">
          <b>Step 2: </b>
          Choose a set with AI materials
        </p>
        <p>
          <b>Step 3: </b>
          On the second step of the “AI set-up” process, select the “Elegance” interior style under the “Select
          interior style” heading
        </p>
        <p>
          With its classic appeal and universal charm, Elegance is designed to meet modern buyers' expectations
          while adding a sense of refinement to your property. Showcase the true potential of your space and boost
          sales with Elegance visualizations from Getfloorplan.
        </p>
      </div>
    ),
    thumb: 'news/32.jpg',
  },
  {
    date: 'November 12, 2024',
    title: 'Why does Real Estate Management trust to AI Getfloorplan?',
    description: 'More than 300  companies over the world trust us to create marketing materials',
    id: 'trust-factors',
    jsx: () => (
      <div class="novelty__text">
        <p>More than 300  companies over the world trust us to create marketing materials</p>
        <p><b>Here are compelling reasons to order 3D images from AI:</b></p>
        <b>Speed and Efficiency</b>
        <p>
          AI-driven 3D modeling significantly reduces the time needed to create high-quality visualizations.
          What traditionally takes days or 3-5 days can be delivered in 24 hours. This speed helps real estate
          professionals and developers accelerate their sales and marketing processes.
        </p>
        <b>Cost-Effectiveness</b>
        <p>
          AI technology automates many manual tasks, reducing labor costs without compromising on quality. This
          makes 3D products more affordable compared to traditional methods, offering a great return on investment
          for businesses. It’s 20$ instead of 70-90$, on average.
        </p>
        <b>Customization and Scalability</b>
        <p>
          AI enables high levels of customization, allowing it to meet tailored specific client needs. Moreover,
          it’s easy to scale up production, whether you need one model or hundreds, ensuring flexibility for
          projects of all sizes.
        </p>
        <p>Write us to have a Demo for your project and get the special conditions.</p>
      </div>
    ),
    thumb: 'news/31.jpg',
    button: 'Personal request',
  },
  {
    date: 'November 6, 2024',
    title: 'More than 200 window views for you - choose and use!',
    description: 'Why is the view through the window in the virtual tour so helpful for property sellers?',
    id: 'window-view',
    jsx: () => (
      <div class="novelty__text">
      <p>
        Why is the view through the window in the virtual tour so helpful for property sellers?
      </p>
      <p>
        <b>1. Enhanced Visualization of Surroundings: </b>
        The “view through the window” feature in virtual tours allows potential buyers to see the actual
        surroundings and views from each room in the property. This representation helps buyers better understand
        the environment, whether it’s a scenic landscape, city skyline, or cozy neighborhood. The more attractive
        the view can positively impact the buyer’s perception and decision-making.
      </p>
      <p>
        <b>2. Emotional Connection: </b>
        Virtual tours that incorporate realistic or close to real atmosphere window views create an immersive experience,
        allowing buyers to picture themselves living in the space. If they can imagine enjoying the views from their living
        room or bedroom, it can build an emotional connection to the property.
      </p>
      <p>
        <b>3. Increased Engagement and Time Spent on the Listing: </b>
        Properties with detailed virtual tours, including realistic views through the windows, keep potential buyers engaged
        longer as they explore the entire setting. The more time a buyer spends interacting with a listing, the higher the
        chances of them developing interest, which in turn increases the likelihood of scheduling an in-person visit or making
        an offer.
      </p>
      <p>
        You can choose a standard window view for free on our website or choose another from our library. If you want to
        choose it from our library, please write it in the comments while placing the order or write us at
        <a href="mailto:customerservice@getfloorplan.com"> customerservice@getfloorplan.com</a>.
        The price is 15$ - is a one time payment for one view. You can use it for many floor plans.  Let’s get started
        to make the 360 tours more impressive.
      </p>
      </div>
    ),
    thumb: 'news/30.jpg',
    button: 'More details about the view',
  },
  {
    date: 'October 18, 2024',
    title: 'New window customization options: choose the color of the frame and glass',
    description: 'Getfloorplan now offers expanded options for users ordering layouts.',
    id: 'window-customization-options',
    jsx: () => (
      <>
        <div class="novelty__text">
        <p>Getfloorplan now offers expanded options for users ordering layouts.</p>
        <p>
          In addition to choosing between panoramic or standard windows, you can specify your preferences
          for frame and glass colors in the comments section of your order. This ensures that the windows
          perfectly match the design of your interior or exterior.
        </p>
        </div>
        <div class="novelty__thumb">
          <img
            alt="news img"
            src={img29part2} />
        </div>
        <div class="novelty__text">
          <b>1. Frame Color</b>
          <p>Users can request a change in window frame color by selecting one of the following options:</p>
          <li class="margin-none"><b>White</b> — a universal option suitable for any interior.</li>
          <li class="margin-none"><b>Brown</b> — a warm shade that fits well with classic or rustic styles.</li>
          <li class="margin-none"><b>Metallic</b> — a modern solution for minimalist or industrial designs.</li>
          <li><b>Mirror metallic</b> — a striking choice for contemporary and futuristic projects.</li>
        </div>
        <div class="novelty__thumb">
          <img
            alt="news img"
            src={img29part3} />
        </div>
        <div class="novelty__text">
          <b>2. Glass Color</b>
          <p>You can also specify your preferences for glass color in the order:</p>
          <li class="margin-none"><b>Clear</b> — a standard option for maximum light penetration.</li>
          <li class="margin-none"><b>Black</b> — a stylish choice to reduce brightness and add a modern touch.</li>
          <li class="margin-none"><b>Tinted</b> — for sun protection and a more comfortable atmosphere.</li>
          <li><b>Frosted</b> — ideal for privacy while maintaining light.</li>
          <p>
            With Getfloorplan, you can now not only select the type of windows but also specify your preferences for
            frame and glass colors, ensuring your project aligns with your style. Take advantage of this option by
            adding your details in the comments section of your order, and receive a layout that fits perfectly into
            your interior. Realize your unique ideas with Getfloorplan — we’ll help you create the space of your dreams!
          </p>
        </div>
      </>
    ),
    thumb: 'news/29_1.jpg',
  },
  {
    date: 'August 27, 2024',
    title: 'Update: New style "Japandi"',
    description: 'Discover the new style – harmony of minimalism and comfort!',
    id: 'japandi-style',
    jsx: () => (
      <div class="novelty__text">
        <p>Discover the new style – harmony of minimalism and comfort!</p>
        <p>
          We are excited to introduce our new style in 3D visualizations —
          <b> "Japandi"</b>.
          This unique blend of Japanese minimalism and Scandinavian functionality will not only transform
          your interior but also turn it into a true oasis of calm and warmth.
        </p>
        <b>Why "Japandi"?</b>
        <p>
          This style is winning hearts worldwide with its ability to combine simplicity and coziness. Clean
          lines, neutral colors, and natural materials create a space that is easy to live in, breathe in, and
          most importantly, sell. "Japandi" is not just beautiful — it helps buyers see the full charm and
          potential of your property.
        </p>
        <b>Ready to try it?</b>
        <p>
          You can now choose the "Japandi" style when ordering 3D visualizations on our website. Add elegance
          and warmth to your projects, and let buyers fall in love with your interior at first sight.
        </p>
        <b>How to Order?</b>
        <p class="margin-none">
          <b>Step 1. </b>
          Visit the storefront section at
          <a href="https://getfloorplan.com"> getfloorplan.com</a>
        </p>
        <p class="margin-none">
          <b>Step 2. </b>
          Click the “Place an order” button on any 3D product card.
        </p>
        <p>
          <b>Step 3. </b>
          On the second step of the “AI set-up” process, select the “Japandi” interior style under the “Select
          interior style” heading.
        </p>
        <p>
          This style not only meets the modern buyer’s expectations but also helps boost sales by offering a
          unique yet versatile design. Sell properties faster with Getfloorplan.
        </p>
      </div>
    ),
    thumb: 'news/28.jpg',
  },
  {
    date: 'August 27, 2024',
    title: 'New update: choose the window type when placing an order',
    description: 'New update: choose the window type when placing an order.',
    id: 'window-type',
    jsx: () => (
      <div class="novelty__text">
        <p>
          Now, on the second step of placing an order, in the "AI set-up" section, you have the
          option to select the type of windows for your layout. This could be a panoramic or standard
          window, depending on your preferences and project specifications.
        </p>
        <p>
          You can also specify the color of the frame in the order comments: white, brown, metallic,
          or metallic mirror. The glass color can also be specified in the comments: standard, black,
          tinted, or frosted.
        </p>
        <p>
          If your property has specific requirements, you can easily communicate your preferences for
          the color of the glass and frame through your account, in the order comments, or by contacting
          our support team. If your layout is already completed but needs adjustments, simply email us,
          and we will update the 3D layout according to the new details.
        </p>
        <p>The process is very simple:</p>
        <p class="margin-none">
          1. Visit our website at
          <a href="https://getfloorplan.com"> getfloorplan.com</a>.
        </p>
        <p class="margin-none">
          2. Select "Place an order" on the page of any of our 3D products.
        </p>
        <p class="margin-none">
          3. On the second step, "AI set-up," choose the window type — panoramic or standard.
        </p>
        <p>
          4. In the order comments, you can leave your preferences for the frame and glass color.
        </p>
        <p>
          Now you can customize your layout to meet your needs and get the final result without extra
          revisions. We are always striving to improve our service and hope that this new feature will
          be useful to you.
        </p>
        <p>Thank you for choosing us!</p>
      </div>
    ),
    thumb: 'news/27.jpg',
  },
  {
    date: 'August 2, 2024',
    title: 'New update on the website —  "Personal Account"',
    description: 'This dashboard is designed to make tracking and storing floor plans more convenient and efficient.',
    id: 'personal-account',
    jsx: () => (
      <div class="novelty__text">
        <p>
          We're updating to become even more convenient for you. We are pleased to introduce
          our new service on the website – the “Personal Account”.
        </p>
        <p>
          This user dashboard is designed specifically to make tracking and storing floor
          plans even more convenient and efficient.
        </p>
        <b>Why do you need a “Personal Account”?</b>
        <p>
          With the “Personal Account”, you get a unique opportunity to store all 3D visualizations
          of your projects in one place. If you need to make changes to a 3D floor plan, you can
          easily send a list of corrections through your personal account. This update is especially
          useful for managing large real estate projects that include 10 to 100 floor plans. Your projects
          will always be organized and accessible through a user-friendly interface.
        </p>
        <b>How to use the new user dashboard?</b>
        <p>To start using the “Personal Account”, follow these steps:</p>
        <p class="margin-none">1. Go to our website:
          <a href="https://getfloorplan.com"> getfloorplan.com</a>
        </p>
        <p class="margin-none">
          2. Click on the “Sign up” button: This will take you to the registration page.
        </p>
        <p>
          3. Fill in the registration fields: If you have previously placed orders, please
          use the same email address used for payment.
        </p>
        <p>
          We are confident that our “Personal Account” update will significantly simplify
          the management of your real estate projects and allow you to interact more efficiently
          with our system. All your content will be stored in one place, and you will be able to
          easily track and make necessary changes.
        </p>
        <p>
          Thank you for choosing Getfloorplan, and we hope that the new update will make your
          experience even more positive.
        </p>
      </div>
    ),
    thumb: 'news/26.jpg',
  },
  {
    date: 'July 26, 2024',
    title: 'Stop losing clients because of a long preparation of property plans',
    description: 'AI will do all the work for you',
    id: 'AI-will-work-for-you',
    jsx: () => (
      <div class="novelty__text">
        <p>AI will do all the work for you: 2D, 3D layouts, 360 in 24 hours</p>
        <p class="margin-none">In one business day our AI will create:</p>
        <ul>
          <li>2D plan</li>
          <li>3D plan</li>
          <li>Renderings</li>
          <li>360-degree video</li>
        </ul>
        <p>Our research on 40,000 ads showed a conversion rate increase from 12.7% to 25%.</p>
        <p class="margin-none">Using Getfloorplan AI, buyers:</p>
        <ul>
          <li>are more likely to click on ads</li>
          <li>spend more time on the property’s page</li>
          <li>save to favorites</li>
          <li>share posts and click on the "call" button</li>
        </ul>
        <p>
          Try our AI today to attract a larger percentage of your target audience, double
          your conversion rate, and outperform your competitors.
        </p>
      </div>
    ),
    thumb: 'news/25.jpg',
  },
  {
    date: 'July 5, 2024',
    title: 'Your Unique Style with Getfloorplan AI',
    description: 'You can order a mix-style design with your own ideas',
    id: 'unique-style',
    jsx: () => (
      <div class="novelty__text">
        <p>You can order a mix-style design with your own ideas.</p>
        <b>What is Mix-Style?</b>
        <p>
          Mix-style is a service where you send us your references, and we use our style
          library to create a demo version of the design for you. We strive to meet your
          requirements by adapting interior elements to your unique needs.
        </p>
        <b>Three Situations When Mix-Style is Necessary:</b>
        <p>
          <br></br>
          1. <b>Regional Features </b>
          If your project requires consideration of specific sculptural or regional features
          that do not conform to the standard styles on our website, mix-style allows you to
          adapt the design to your unique requirements.
          <br></br>
        </p>
        <p>
          2. <b>Existing Design Style </b>
          If you already have a specific idea about the style of your property and need to align
          the project with this design style, mix-style will help you achieve the desired result.
          <br></br>
        </p>
        <p>
          3. <b>Unconventional Ideas </b>
          If you have unique and unconventional ideas, mix-style allows you to create a demo version
          of the design based on the references you provide. This is especially relevant when ordering
          from three to five projects.
          <br></br>
        </p>
        <p><b>How to Order a Custom Style:</b></p>
        <p>
          1. Describe the project
          <br></br>
          2. Specify the number of layouts
          <br></br>
          3. Mention special requirements (style, view from the window, etc.)
          <br></br>
          4. Send your request
          <a href="mailto:a.kogan@getfloorplan.com"> a.kogan@getfloorplan.com</a>
          <br></br>
        </p>
        <p>Sell property faster with Getfloorplan</p>
      </div>
    ),
    thumb: 'news/24.jpg',
  },
  {
    date: 'June 27, 2024',
    title: 'Discover the Getfloorplan YouTube Channel!',
    description: 'A valuable resource for everyone interested in real estate',
    id: 'youtube-channel',
    jsx: () => (
      <div class="novelty__text">
        <p>A valuable resource for everyone interested in real estate.</p>
        <p>
          On our channel, you'll find a wealth of useful information, news, and reviews to help
          you stay updated on the latest trends and innovations in the real estate industry.
        </p>
        <b>What to Expect on Our Channel?</b>
        <br/><br/>
        <b>Useful Information for Clients</b>
        <ul>
          <li>Learn how to effectively use our floorplans, 3D tours, and visualization services.</li>
          <li>Tips and recommendations for improving your property presentations.</li>
        </ul>
        <b>Real Estate News</b>
        <ul>
          <li>Stay informed about the latest events and changes in the real estate market.</li>
          <li>Analysis and forecasts to help you make more informed decisions.</li>
        </ul>
        <b>Style Reviews</b>
        <ul>
          <li>Detailed reviews of various layout and interior styles.</li>
          <li>Ideas and inspiration for your next project.</li>
        </ul>
        <b>Free Webinars</b>
        <ul>
          <li>Join our webinars and learn from the best experts in the industry.</li>
          <li>Get answers to your questions and enhance your skills.</li>
        </ul>
        <b>And Much More Useful Information</b>
        <p>
          Subscribe to our channel so you don't miss any updates. We regularly publish new videos
          to help you stay at the forefront of the real estate market and make the most of our services.
        </p>
        <b>Don't forget to subscribe, hit the bell icon, and stay tuned for updates!</b>
        <p>
          Join the Getfloorplan community on YouTube and gain access to the most current and useful
          materials in the real estate industry.
        </p>
      </div>
    ),
    thumb: 'news/23.jpg',
  },
  {
    date: 'June 20, 2024',
    title: 'Update: New style "Modern"',
    description: 'The new interior design attracts buyers to real estate',
    id: 'update-style-modern',
    jsx: () => (
      <div class="novelty__text">
        <p>We are pleased to introduce our new interior style - "Modern".</p>
        <p>
          This style is characterized by refined, clean, and minimalist design, emphasizing simplicity and elegance.
          <br/>
          Key features of "Modern" include:
        </p>
        <b>Neutral palette</b>
        <p>White, gray, and beige tones create an elegant background.</p>
        <b>Clean lines</b>
        <p>Straight lines and streamlined shapes ensure order.</p>
        <b>Minimalism</b>
        <p>Minimal decorations with focus on a few key elements.</p>
        <b>High-quality materials</b>
        <p>Marble countertops, parquet floors, and metal fixtures.</p>
        <p>
          The "Modern" style is versatile and suitable for a wide audience who values comfort and modern amenities.
          By selling real estate with this style, you can attract buyers faster and stand out among competitors.
        </p>
        <p>The new style is already available on our website!</p>
      </div>
    ),
    thumb: 'news/22.jpg',
  },
  {
    date: 'June 14, 2024',
    title: 'What changes can be made to the Getfloorplan layouts?',
    description: 'After processing, we can manually adjust the floor plan as needed',
    id: 'layouts-changes',
    jsx: () => (
      <div class="novelty__text">
        <p>After processing, we can manually adjust the floor plan as needed</p>
        <p>We can make the following changes to your project:</p>
        <ul>
          <li>Add, move, or remove furniture.</li>
          <li>Add or remove walls.</li>
          <li>Add, move, or remove windows and doors.</li>
          <li>Change the size of rooms.</li>
        </ul>
        <p>
          Additionally, we can work with you to create a custom style that meets your needs.
          <br></br>
          For example: customize color schemes, develop textures, and add textile elements.
        </p>
        <p>
          Moreover, we can create an entirely new style with different furniture, interior
          elements, textures, and textiles.
        </p>
        <p>
          For more information about our services or to discuss your specific needs, contact us at
          <a href="mailto:support@getfloorplan.com"> support@getfloorplan.com</a>.
          We are here to ensure your floor plan looks exactly how you want it to!
        </p>
      </div>
    ),
    thumb: 'news/21.png',
  },
  {
    date: 'June 6, 2024',
    title: 'Why GETFLOORPLAN is perfect for developers',
    description: '3D, 360 tours, and renders by AI',
    id: 'why-getfloorplan',
    jsx: () => (
      <div class="novelty__text">
        <p>
          In the fast-paced real estate market, developers need efficient and cost-effective solutions to stay
          competitive. Getfloorplan offers just that.
        </p>
        <b>Speed</b>
        <p>
          Our advanced AI technology creates detailed floor plans, 3D visualizations, renders, and virtual tours
          in just 24 hours, allowing developers to bring projects to market faster.
        </p>
        <b>Cost-Effective</b>
        <p>
          Traditional 3D visualizations can be expensive, but Getfloorplan’s services start at just $20, making
          it a budget-friendly option without compromising quality.
        </p>
        <b>Customization</b>
        <p>
          We offer a service for creating a unique style. We tailor our visualizations to match the unique style
          of your projects, ensuring that the final product meets your specific needs and aesthetics.
        </p>
        <p>
          With Getfloorplan, developers can streamline their processes, reduce costs, and enhance their marketing
          materials, making it the ideal choice for modern real estate projects.
        </p>
        <p>Join the revolution in real estate with Getfloorplan!</p>
      </div>
    ),
    thumb: 'news/20.png',
    video: 'https://www.youtube.com/embed/eTTleQYWI34?si=HbvXXs0S2Wk2sTlx',
  },
  {
    date: 'May 30, 2024',
    title: 'New video: discover everything about our "render set"!',
    description: 'The "Render Set" offers a unique opportunity to purchase high-quality interior renderings of residential properties, along with 2D and 3D floor plans',
    id: 'render-set',
    jsx: () => (
      <div class="novelty__text">
        <p>
          The "Render Set" offers a unique opportunity to purchase high-quality interior renderings of residential
          properties, along with 2D and 3D floor plans. This package is designed for those who value quality and want
          to showcase real estate in the best possible light.
        </p>
        <p>Benefits of High-Quality Renderings for Real Estate Sales:</p>
        <p>
          <u>Attracting Attention</u>
          : Beautiful and realistic images capture the interest of potential buyers, creating an unforgettable first impression.
        </p>
        <p>
          <u>Demonstrating Potential</u>
          : Renderings help show how a space can be furnished, which is especially important for empty or under-construction
          properties.
        </p>
        <p>
          <u>Emotional Engagement</u>
          : Realistic visualizations evoke an emotional response, allowing potential buyers to imagine themselves in their
          new home.
        </p>
        <p>
          <u>Increasing Sales</u>
          : Studies show that high-quality renderings can speed up the sales process and increase the transaction value.</p>
        <p>
          <u>Convenience for Online Presentations</u>
          : In today's world, many buyers start their property search online. High-quality renderings make online presentations
          more attractive and informative.
        </p>
        <p>Want to learn more about the "Render Set"? Watch our video for all the details!</p>
      </div>
    ),
    thumb: 'news/19.jpg',
    video: 'https://www.youtube.com/embed/EgthefVRr2s?si=ZHOSfDoQFOYcVCMa',
  },
  {
    date: 'May 23, 2024',
    title: 'Site Updates: New Layout Sets Showcase and Improved Order Form',
    description: 'We are pleased to announce new updates on our website that will make the process of choosing and ordering layouts even more convenient and efficient for you!',
    id: 'new-order-form',
    jsx: () => (
      <div class="novelty__text">
        <p>
          We are pleased to announce new updates on our website that will make the process of choosing
          and ordering layouts even more convenient and efficient for you!
        </p>
        <b>New Layout Sets Showcase</b>
        <p>
          We now have a showcase with layout sets available on our website. You can choose the set you
          are interested in and review its contents before purchasing. This allows you to clearly understand
          what is included in each package and make an informed decision.
        </p>
        <b>Convenient Order Form</b>
        <p>
          We have also updated the order form to make the process even simpler and more user-friendly.
          Depending on the chosen package, you now have the ability to:
        </p>
        <ul>
          <li>Specify the number of floors.</li>
          <li>Choose the style and view from the window.</li>
          <li>Add your logo.</li>
          <li>Leave a link to your website.</li>
          <li>Leave a comment to clarify details.</li>
          <li>Preview your order before payment.</li>
        </ul>
        <b>Why is this important?</b>
        <p>
          These updates are designed to make your experience with our website even more pleasant and effective.
          You can appreciate the convenience of the new features and quickly order the layout of your property.
          This will allow you to sell properties faster, saving your resources and time.
        </p>
        <p>
          We strive for continuous improvement of our service and hope that these changes will assist you in
          your work. Try the new features and see for yourself how convenient they are!
        </p>
        <p>Order your property layout right now and enjoy all the benefits of the updated website!</p>
      </div>
    ),
    thumb: 'news/18.png',
  },
  {
    date: 'May 16, 2024',
    title: 'New feature release: high-quality ai-produced real estate images',
    description: 'Learn more about how to update your real estate listings and attract more clients',
    id: 'new-feature-release',
    jsx: () => (
      <div class="novelty__text">
        <p>We are pleased to introduce our new product - "Render set"!</p>
        <p>
          "Render set" offers the opportunity to purchase high-quality interior renderings of residential
          properties along with 2D and 3D floor plans.
        </p>
        <p>
          Our product "Render set" solves the problem of placing renders on real estate listing websites.
          Now users can obtain all the necessary visual materials for their listing in one place at an
          affordable price. Additionally, "Render set" makes it easy to embed virtual tours on any website.
        </p>
        <p>
          Our renderings look natural and familiar to the human eye on real estate listing websites, as they
          closely resemble actual property photos.
        </p>
        <p>The new "Render set" will be available at the end of May on our website!</p>
      </div>
    ),
    thumb: 'news/17.png',
  },
  {
    date: 'May 8, 2024',
    title: 'What types of views can Getfloorplan generate from the window?',
    description: 'Explore the enticing array of views that not only capture the imagination but also allure potential real estate buyers',
    id: 'types-of-views',
    jsx: () => (
      <div class="novelty__text">
        <p>
          Explore the variety of views that capture the imagination and attract potential real
          estate buyers, aiding in making faster decisions on property purchases:
          <br></br><br></br>
          1. City View: Perfect for urbanites craving a vibrant lifestyle with easy access to
          amenities and entertainment.
          <br></br><br></br>
          2. Village View: Ideal for those who cherish a peaceful, tight-knit community vibe
          with a hint of rustic charm.
          <br></br><br></br>
          3. Garden View: Tailored for nature enthusiasts who appreciate tranquility, bringing
          the beauty of the outdoors inside with lush, green surroundings.
          <br></br><br></br>
          4. Sandy Shore View: Designed for beach aficionados, offering stunning ocean views and
          a laid-back, coastal lifestyle.
          <br></br><br></br>
          5. Pool View: Suited for individuals seeking luxury and leisure, featuring a private
          oasis complete with a refreshing swim and appealing landscape.
          <br></br>
        </p>
        <p>
          Experience the enchantment of these captivating views firsthand by trying out our
          innovative artificial intelligence service. Whether you're a real estate developer
          looking to enhance property offerings or a private seller of residential space, our
          technology will help you visualize the possibilities with stunning accuracy and sell
          properties faster.
        </p>
      </div>
    ),
    thumb: 'news/16.png',
  },
  {
    date: 'May 2, 2024',
    title: "The Getfloorplan layouts are more realistic now. We've added sunlight",
    description: 'With "Sunlight," your home for sale will become even cozier and more comfortable',
    id: 'sunlight',
    jsx: () => (
      <div class="novelty__text">
        <p>
          We have some exciting news for you! Getfloorplan layouts have become even more realistic.
          We've added sunlight to them.
        </p>
        <p>Now users can enjoy even more realistic virtual tours and 3D floor plans.</p>
        <p>
          With "Sunlight," your home for sale will become even cozier and more comfortable. Imagine:
          sunlight streaming through the windows, creating an atmosphere of warmth and coziness in every room.
        </p>
        <p>
          Now your clients can truly feel at home, even in virtual space. They can see how their home will look
          on a sunny day, helping them make more informed decisions when planning their future housing. Experience
          realism with Getfloorplan and create your ideal home today!
        </p>
      </div>
    ),
    thumb: 'news/15.png',
  },
  {
    date: 'April 26, 2024',
    title: 'Cut costs, save time: The comprehensive advantage of AI Getfloorplan for developers',
    description: 'AI Getfloorplan is revolutionizing the real estate marketing landscape, offering developers a suite of key advantages',
    id: 'cut-costs',
    jsx: () => (
      <div class="novelty__text">
        <p>
          AI Getfloorplan is revolutionizing the real estate marketing landscape, offering developers a
          suite of key advantages that position this tool as indispensable in today's market. These features
          make the solution particularly appealing to marketing executives for several compelling reasons:
        </p>
        <b>Cost-efficiency in marketing spend</b>
        <p>
          Traditional companies might charge around $130 for a single floor plan. In contrast, AI Getfloorplan
          performs the same task for just $20. A batch of ten floor plans, which would typically cost $1300 with
          competitors, is priced at only $200 with us. This represents a substantial 85% saving on your marketing budget.
        </p>
        <b>Branding integration in virtual tours</b>
        <p>
          We provide an opportunity to embed your brand directly into virtual tours, enhancing brand recognition
          and customer loyalty. This feature ensures that every potential buyer immerses themselves in the project
          while continuously engaging with your brand identity, strengthening the connection with your company.
        </p>
        <b>Rapid turnaround for large volumes</b>
        <p>
          While other services might offer to develop 10 floor plans over 3-7 days, AI Getfloorplan promises to
          deliver any volume of orders within just 24 hours. This capability means you can bring your projects
          to market much faster. The inclusion of an API for transferring large data volumes guarantees seamless
          integration with your systems and accelerates workflows.
        </p>
        <b>Personalized approach to each project</b>
        <p>
          Our global experience with developers allows us to tailor the style and approach to each project uniquely.
          For instance, for an american developer in need of 25 layouts, we proposed our Scandy style and then fine-tuned
          it to match the specifics of their property, achieving impressive results that fully met their expectations.
        </p>
        <b>Variety of styles for personalization</b>
        <p>
          Additionally, we offer a wide range of visualization styles, including specialized options for developers
          like white box and gray shell. These styles enable developers to present potential buyers with various
          finishing and layout options, making the projects more attractive and personalized.
        </p>
        <p>
          With AI Getfloorplan, you not only save on your marketing budget but also receive a product that aligns
          perfectly with market needs and buyer preferences.
        </p>
      </div>
    ),
    thumb: 'news/14.png',
  },
  {
    date: 'April 18, 2024',
    title: 'Adding a Tesla to floor plans with a garage!',
    description: 'We have incorporated cars into the garage layouts, expanding the possibilities of visualizing future homes.',
    id: 'Adding-a-Tesla-to-floor-plans-with-a-garage',
    jsx: () => (
      <div class="novelty__text">
        <p>We have incorporated cars into the garage layouts, expanding the possibilities of visualizing future homes.</p>
        <p>
          This is not just an addition to the layout - it's about creating a more realistic picture of life in a new
          house. Now, when potential buyers browse house plans, they can not only see spacious rooms and functional
          relaxation areas but also envision their car, comfortably parked in the garage.
        </p>
        <p>
          This detail adds an important aspect of reality and coziness, allowing clients not just to consider options
          but also to emotionally connect with their future home. Imagine how easily you can envision yourself in this
          space, feeling at home, already seeing your car, ready for adventures, in the garage.
        </p>
        <p>
          Thanks to this level of visualization, clients can easily picture themselves in the new space, making the
          process of choosing a home more engaging and interactive. The resulting impression reinforces confidence in
          the choice and makes the anticipation of moving into a new home even more exciting.
        </p>
      </div>
    ),
    thumb: 'news/13.png',
  },
  {
    date: 'April 11, 2024',
    title: 'What changes can be made to the Getfloorplan layouts?',
    description: 'Getfloorplan team can manually change your floor plan after it has been processed:',
    id: 'what-changes-can-be-made-to-the-Getfloorplan-layouts',
    jsx: () => (
      <div class="novelty__text">
        <p>Getfloorplan team can manually change your floor plan after it has been processed:</p>
        <p>We can make the following modifications:
          <br></br>
          1. Add, move, or remove furniture.
          <br></br>
          2. Add or remove walls.
          <br></br>
          3. Add, move, or remove windows and doors.
          <br></br>
          4. Resize rooms.
          <br></br>
        </p>
        <p>
          If you have specific requests beyond the ones above, we can also collaborate on an
          individual style that suits your needs.
          <br></br>
          This includes customizing color schemes, textures, and textile elements.
        </p>
        <p>
          Moreover, we can develop an entirely new style featuring different furniture,
          interior elements, textures, and textiles.
        </p>
        <p>
          For more detailed information about the services or to discuss your specific requirements,
          please, feel free to contact us via email
          <a href="mailto:support@getfloorplan.com"> support@getfloorplan.com</a>.
          We’re here to make sure your floor plan looks exactly as you wish!
        </p>
      </div>
    ),
    thumb: 'news/12.png',
  },
  {
    date: 'April 04, 2024',
    title: 'New style — “Modern”',
    description: 'In the new article, we have discussed the features of the new style and how it helps to sell real estate.',
    id: 'new-style-modern',
    jsx: () => (
      <div class="novelty__text">
        <p>
          In the world of real estate, first impressions play a huge role. Buyers often make decisions about
          purchasing property based on how it looks. That's why it's important to present your property in the
          best light possible. With the emergence of a new style called "Modern," the real estate selling
          process has become even more convenient and efficient.
        </p>
        <p>
          The new "Modern" style from Getfloorplan represents an innovative approach to visualizing real estate.
          This style has been developed taking into account the latest trends in interior and exterior design.
          It combines modern elements and styles that give spaces a fresh and attractive look.
        </p>
        <p>Why your potential buyers will like this style:</p>
        <u>Appeals to a wide audience</u>:
        <p>
          The neutral palette of the modern style and minimalist approach make it a universal choice, catering
          to a wide range of tastes, ensuring that the property will appeal to a broad audience.
        </p>
        <u>People appreciate comfort</u>:
        <p>
          Open floor plans and efficient use of space are attractive to clients who prioritize living comfort
          and modern amenities.
        </p>
        <u>Grabs attention</u>:
        <p>
          Properties with modern interiors create impressive virtual tours, making them more appealing in
          digital and print formats.
        </p>
        <p>
          The new style opens up new opportunities for selling real estate, helping to present properties
          in the best light possible.
        </p>
        <p>
          Thanks to its modern and attractive interior design, this style attracts the attention of potential
          buyers and helps them better envision their future space. Incorporate the new style into your projects
          to increase sales performance.
        </p>
        <p>The new style will be available on our website on April 15, 2024.</p>
      </div>
    ),
    thumb: 'news/11.png',
  },
  {
    date: 'March 28, 2024',
    title: 'AI helps developers create Internal renders',
    description: 'Properties presented using AI visualizations attract 15% more attention from buyers.',
    id: 'AI-helps-developers-create-Internal-renders',
    jsx: () => (
      <div class="novelty__text">
        <p>
          In the world of real estate, a crucial factor for success is the ability to capture the
          attention of potential buyers and convince them of the appeal of the offered properties.
          With the emergence of artificial intelligence (AI), the process of creating visualizations
          for developers has become more efficient and persuasive. Our company, Getfloorplan, is pleased
          to introduce you to the unique opportunities that AI visualizations offer to developers.
        </p>
        <u>Realism and Attractiveness</u>
        <p>
          AI-generated visualizations created by our platform are characterized by a high degree of realism.
          They allow potential buyers to immerse themselves inside the property and visually assess its quality.
          Realistic images attract attention and create a positive impression of the project.
        </p>
        <u>Variety and Flexibility</u>
        <p>
          With AI visualizations, developers can present properties in various stages of completion – from
          rough drafts to fully furnished interiors. This enables them to showcase different layout and
          design options, catering to the individual preferences of clients.
        </p>
        <u>Time and Resource Efficiency</u>
        <p>
          Creating AI visualizations on our platform requires minimal time (just 24 hours) and resources.
          This enables developers to present their projects on the market more quickly and efficiently,
          reducing the time and cost of visualization development.
        </p>
        <u>Remote Assessment and Improved Communication</u>
        <p>
          AI visualizations allow potential buyers to assess a property remotely. Thanks to realistic images,
          clients can examine every detail of the interior and exterior, making more informed purchasing
          decisions. Additionally, visualizations serve as a tool to improve communication between developers
          and clients, helping to better understand and meet their needs and preferences.
        </p>
        <u>Project Promotion and Increased Conversion</u>
        <p>
          Attractive and realistic AI visualizations help developers effectively promote their projects on
          the market. They attract the attention of potential buyers, creating a positive impression of the
          project, ultimately increasing conversion rates and deal success.
        </p>
        <p>Get a floor plan anywhere, anytime. Use Getfloorplan to create floor plans without any professional skills.</p>
      </div>
    ),
    thumb: 'news/10.png',
  },
  {
    date: 'March 22, 2024',
    title: 'New styles for real estate developers: white box and grey shell!',
    description: 'We have created styles that showcase the potential of real estate in rough and finished finishes.',
    id: 'new-style-for-real-estate-developers',
    jsx: () => (
      <div class="novelty__text">
      <p>
        Many property buyers prefer to see not only beautiful visualizations but also the actual space
        of their future home. Developers face the challenge of accurately conveying the real appearance
        and potential of properties during the development stage. The inability to view spaces in their
        true form slows down the sales process and can lead to misunderstandings between developers and
        buyers. In response to this, we are pleased to introduce our new product: virtual tour services
        available in White Box and Grey Shell formats.
      </p>
      <b>Why is this necessary?</b>
      <p>
        <u>Realism</u>
        : Showing real space helps buyers better understand and envision their future home or apartment.
        <br></br>
        <u>Immersion</u>
        : Virtual tours create deeper immersion in the space, facilitating faster decision-making.
        <br></br>
        <u>Time-saving</u>
        : Thanks to the absence of the need for physical visits, our virtual tours streamline the sales
        process for both your team and clients.
      </p>
      <b>Key Features:</b>
      <p>
        <u>Realistic Presentations</u>
        : Our tours accurately depict spaces in both White Box and Grey Shell formats.
        <br></br>
        <u>True-to-Life Representation</u>
        : Minimizing the gap between buyer expectations and reality by presenting properties in their natural state.
        <br></br>
        <u>Seamless Integration</u>
        : Our virtual tours are easy to integrate and use for your team and clients, ensuring smooth operation
        for all participants.
      </p>
      <p>
        Remember, the decision to purchase real estate is an important step, and transparency plays
        a key role in establishing trust with clients. By using our virtual tours, you can increase
        sales efficiency and customer satisfaction.
      </p>
      <p>
        Don't miss the opportunity to improve sales strategies and provide unparalleled clarity for
        your clients through our virtual tours!
      </p>
      <p>The new styles will be available in April 2023.</p>
      </div>
    ),
    thumb: 'news/9.png',
  },
  {
    date: 'March 15, 2024',
    title: 'EU AI Act: first regulation on artificial intelligence',
    description: 'This document sets out obligations for the use of AI, based on its potential risks and impact.',
    id: 'first-regulation-on-AI',
    jsx: () => (
      <div class="novelty__text">
        <p>This document sets out obligations for the use of AI, based on its potential risks and impact.</p>
        <p>
          The new rules prohibit certain AI applications that may threaten citizens' rights, such as
          biometric categorization systems based on confidential characteristics or the non-targeted
          collection of facial images from the internet. It also prohibits emotion recognition in the
          workplace and the use of AI to manipulate people's behavior.
        </p>
        <p>
          The law establishes clear obligations for high-risk AI systems, such as critical infrastructure
          and migration management, including risk assessment and reduction, transparency, and human oversight.
        </p>
        <p>
          Our service, Getfloorplan, guarantees full compliance with all requirements of the new Artificial
          Intelligence Act. We continue to strive for high standards of security and ethics in the use of our
          technologies, providing reliable solutions for our clients in all countries.
        </p>
        <p>
          Following technical clarifications, the Act must be formally adopted by the Council of the EU and
          come into force twenty days after publication in the Official Journal of the European Union, fully
          applicable within 24 months.
        </p>
      </div>
    ),
    thumb: 'news/8.png',
  },
  {
    date: 'March 7, 2024',
    title: 'The new «Ruler» tool!',
    description: 'Elevate your presentations and sales effectiveness with our latest feature!',
    id: 'ruler',
    jsx: () => (
      <div class="novelty__text">
        <p>Elevate your presentations and sales effectiveness with our latest feature!</p>
        <p>
          «Ruler» Feature: This new function in our virtual tours allows for precise
          measurements of furniture sizes and distances between multiple points in a space.
          It will enable your clients to select the right-sized furniture and accurately
          estimate the quantity of the materials needed for renovations.
        </p>
        <p>How to use the "Ruler" tool? It's simple:</p>
        <p>
          1. Click on the ruler icon.
          <br></br>
          2. When the circle appears, click – this will be the first measurement point.
          <br></br>
          3. Move the cursor and click to set the second point. The measurement in meters
          and feet will appear. You can easily reset the measurement by clicking or
          continue measuring as needed.
        </p>
        <p>
          This tool will become an indispensable assistant in your work, providing accurate data
          and enhancing your virtual tours. Enjoy the benefits of the "Ruler" from Getfloorplanand
          make successful deals! Thank you for your attention, and we wish you productive work with our tools!
        </p>
        <p>
          When placing an order, enter the promo code RULER, and receive this tool as a
          gift with any package you choose.
        </p>
        <p>Don't miss the opportunity to avail of this feature for free until  April 31, 2024.</p>
      </div>
    ),
    thumb: 'news/7.png',
  },
  {
    date: 'March 1, 2024',
    title: 'New feature: virtual property tours using vr headset',
    description: '"VR Mode" offers a 360-degree virtual property tour experience through virtual reality headsets.',
    id: 'new-feature',
    jsx: () => (
      <div class="novelty__text">
        <p>"VR Mode" offers a 360-degree virtual property tour experience through virtual reality headsets.</p>
        <p>Key Features of "VR Mode":</p>
        <b>Immersive 360-Degree Tours:</b>
        <p>
          With "VR Mode" from Getfloorplan, users can immerse themselves in 360-degree virtual property
          tours. This means you can virtually navigate every corner of your prospective property, evaluating
          its spaciousness and ambiance without leaving your office.
        </p>
        <b>Virtual Reality Headset Compatibility:</b>
        <p>
          The feature supports modern virtual reality headsets, transforming routine property viewing
          into an engaging adventure. Oculus, HTC Vive, and other popular VR headsets are seamlessly integrated.
        </p>
        <b>Detailed Floor Plans:</b>
        <p>
          Through VR Mode, detailed floor plans and interior designs come to life. Users can virtually
          "test" the space, moving from room to room, assessing furniture placement and dimensions.
        </p>
        <p>Now, your clients can fully engage with the world of real estate through "VR Mode" by Getfloorplan!</p>
        <p>
          Don't miss the opportunity to avail of this feature for free until April 31, 2024, by adding it
          to your Plus set or Pro set order. Dive into the future today!
        </p>
      </div>
    ),
    thumb: 'news/6.png',
  },
  {
    date: 'February 23, 2024',
    title: '5 reasons to add a floor plan in your Airbnb listing',
    description: 'The use of 2D and 3D floor plans on Airbnb when renting accommodation has undeniable advantages:',
    id: '5-reasons-to-add-a-floor-plan',
    jsx: () => (
      <div class="novelty__text">
        <p>The use of 2D and 3D floor plans on Airbnb when renting accommodation has undeniable advantages:</p>
        <b>Visual Clarity:</b>
        <p>
          2D and 3D floor plans provide guests with a clear understanding of the structure and layout of the space.
          This helps avoid misunderstandings and creates a more transparent perception of the rental property.
        </p>
        <b>Time Savings for Guests:</b>
        <p>
          Detailed plans expedite the decision-making process for guests. They can quickly assess whether
          the accommodation meets their needs, saving time in the selection and booking process.
        </p>
        <b>Builds Trust:</b>
        <p>
          Providing 2D and 3D floor plans creates an impression of trust. Guests see that hosts are open and willing to
          share detailed information about their property, influencing the level of comfort and confidence during booking.
        </p>
        <b>Maximum Information:</b>
        <p>
          Floor plans help convey maximum information about the space, including room sizes and their layout.
          This is particularly important for guests evaluating rental properties in unfamiliar locations.
        </p>
        <b>Easier Planning:</b>
        <p>
          Guests can plan their stay more easily using 2D and 3D floor plans. This allows them to choose
          the most convenient accommodation options and adapt the space to their needs.
        </p>
        <p>
          The use of 2D and 3D floor plans on Airbnb becomes a key factor in improving the guest experience and creating
          a more efficient and convenient booking process.
        </p>
      </div>
    ),
    thumb: 'news/5.png',
  },
  {
    date: 'October 9, 2023',
    title: '3 uses of AI in real estate',
    description: "When you think of artificial intelligence (AI) in real estate, you probably don't think of it",
    id: '3-uses-of-ai-in-real-estate',
    jsx: () => (
      <div class="novelty__text">
        <p>
          When you think of artificial intelligence (AI) in real estate, you probably don't think of it.
          However, like much of the business world, the real estate industry is embracing the power of
          artificial intelligence (AI).
        </p>
        <p>
          1. One common application of AI in real estate is predictive analytics,
          used for real estate valuation and predicting market trends.
        </p>
        <p>
          2. 3D modeling and "digital twins" allow users to explore properties digitally,
          increasing potential buyers and saving time and money.
        </p>
        <p>
          3. AI aids in property management, from tenant screening with chatbots to payment
          processing and reporting for improved efficiency.
        </p>
        <p>
          Will AI change the world of real estate?<br/>Real estate is a massive, fragmented industry
          that is typically slow to change, but the examples above show that AI is already having an impact
          in areas like predictive analytics, property estimates, smart home devices, mortgages, and others.
        </p>
      </div>
    ),
    thumb: 'news/4.png',
  },
  {
    date: 'October 2, 2023',
    title: "'Find your paint points.' Real estate agents use AI to save time, focus on key tasks",
    description: 'Real estate agents are using Chat GPT to streamline their work, making it more efficient',
    id: 'real-estate-agents-use-ai-to-save-time',
    jsx: () => (
      <div class="novelty__text">
        <p>
          Real estate agents are using Chat GPT to streamline their work, making it more efficient.
          AI assists with generating property descriptions, saving time and alleviating writer's block.
          It complements real estate agents' tasks by handling routine jobs, like creating scripts
          and mimicking handwriting for personalized letters. However, as AI experiments expand,
          transparency and ethical use are paramount, ensuring no deception in property marketing.
        </p>
        <p>
          Ryan Castle, Executive Director of the Cape Cod and Islands Association of Realtors,
          emphasizes the need for agents to think carefully about how AI can enhance their roles,
          automating tasks and enabling a focus on client-centric activities. While AI is valuable,
          it doesn't replace the vital role of real estate agents who possess local market knowledge
          and negotiation expertise. The human touch remains irreplaceable in the real estate industry.
        </p>
      </div>
    ),
    thumb: 'news/3.png',
  },
  {
    date: 'September 25, 2023',
    title: 'Top 3 questions of real estate developers sales process',
    description: 'Real estate developers face three critical challenges in their quest for success:',
    id: 'top-3-questions-of-real-estate-developers-sales-process',
    jsx: () => (
      <div class="novelty__text">
        <p>1. How do I sell all my properties as quickly as possible?</p>
        <p>2. How do you figure out who to delegate sales to if you can't do it yourself?</p>
        <p>3. How do you get qualified leads to accelerate sales?</p>
        <p>
          These questions keep developers up at night, and their primary metric for success?
          It's all about speed!
        </p>
        <p>
          According to our survey, a whopping 76% of participants chose speed as the top metric
          in the real estate sales process. Speed matters in every aspect, from swiftly gathering
          information, creating compelling visuals, to sealing the deal.
        </p>
        <p>
          The solution is clear: Give developers the tools they need to accelerate the process,
          and you'll have them hooked. Speed is the name of the game, and in the fast-paced world
          of real estate, those who can keep up are the ones who win.
        </p>
      </div>
    ),
    thumb: 'news/1.png',
  },
  {
    date: 'September 18, 2023',
    title: 'AI in action: Microsoft, YouTube and more',
    description: 'Artificial Intelligence (AI) is revolutionizing our world, and the latest news showcase its remarkable impact',
    id: 'ai-in-action-microsoft-youtube-and-more',
    jsx: () => (
      <div class="novelty__text">
        <p>
          Artificial Intelligence (AI) is revolutionizing our world, and the latest news showcases
          its remarkable impact. Microsoft is set to integrate DALL-E 3, an advanced AI image
          generator, into Bing, enhancing visual search experiences. YouTube is embracing generative AI,
          promising to revolutionize content creation with features like dubbing, background creation,
          and idea generation.
        </p>
        <p>
          In practical applications, Toyota has shown how AI can teach robots to make breakfast
          through demonstrations. Meanwhile, TikTok is addressing transparency concerns by introducing
          AI content labeling, allowing users to differentiate between content created by humans and AI.
        </p>
        <p>
          AI's influence goes beyond entertainment; it's a force for positive change.
          Large companies like Microsoft and Google recognize its potential, racing to lead the AI
          frontier. Moreover, the UK's proposed AI regulation principles and creative collaborations
          like AI-designed Coca-Cola underscore AI's evolution into a serious and impactful societal
          step. AI isn't just a trend; it's becoming an integral part of our lives, offering
          practical benefits and shaping a more accountable future.
        </p>
      </div>
    ),
    thumb: 'news/2.png',
  },
];
